const Kedrab = () => {
  return (
    <>
      <div className="mx-auto">
        <div className="mt-10 font-bold">PATIENT ELIGIBILITY GUIDELINES FOR COPAY ASSISTANCE</div>

        <ul className="list-disc ml-10">
          <li className="my-2">
            Patients must be United States citizens or permanent residents, and must physically
            reside in the United States or its territories.
          </li>
          <li className="my-2">
            Proof of residency will not routinely be required but may be requested at any time
            through an audit (i.e, copy of valid driver’s license or recent utility bill).
          </li>
          <li className="my-2">
            Patients’ annual gross income must not exceed 250% of the Federal Poverty Level (FPL).
            Valid proof of income will be required.
          </li>
          <li className="my-2">Patients must be uninsured.</li>
          <li className="my-2">
            Patients must be under the care of a licensed prescriber with an established clinical
            practice located in the United States or its territories.
          </li>
          <li className="my-2">
            Patient diagnosis and dosing must be consistent with U.S. Food and Drug Administration
            regulations.
          </li>
          <li className="my-2">Patients will receive one (1) prescribed dose.</li>
          <li className="my-2">
            Patients receiving federally funded benefits will not be eligible to receive assistance
            under the Program. Such excluded patient benefits include, but may not be limited to:
            Medicare, Medicaid (including spend downs), Tricare, and VA benefits.
          </li>
        </ul>
      </div>
    </>
  );
};

export default Kedrab;
